import { createGlobalState } from "@vueuse/core";
import { onMounted, shallowRef } from "vue";

export const useLoginState = createGlobalState(() => {
  onMounted(async () => {
    if (!user.value) {
      const { $auth } = await import("@/api.client");
      user.value = await $auth.getMe();
    }
  });
  const user = shallowRef<{ name: string; email: string }>();
  const showLogin = shallowRef<"signup" | "login" | undefined>();
  return { showLogin, user };
});
